import { memo } from 'motion-utils';
var supportsScrollTimeline = /* @__PURE__ */memo(function () {
  return window.ScrollTimeline !== undefined;
});
export { supportsScrollTimeline };